// extracted by mini-css-extract-plugin
export default {"div__1":"Side_div__1__739wf"};